import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ArticleComponent } from "./article/article.component";
import { BanniereComponent } from "./banniere/banniere.component";
import { BloguesComponent } from "./blogues/blogues.component";
import { CaracteristiqueComponent } from "./caracteristique/caracteristique.component";
import { CategorieComponent } from "./categorie/categorie.component";
import { ContentManagerComponent } from "./content-manager/content-manager.component";
import { EquipeTravailComponent } from "./equipe-travail/equipe-travail.component";
import { GroupeCategorieComponent } from "./groupe-categorie/groupe-categorie.component";
import { IndexComponent } from "./index/index.component";
import { InstagramComponent } from "./instagram/instagram.component";
import { LinkComponentComponent } from "./link-component/link-component.component";
import { ListeArticlesComponent } from "./liste-articles/liste-articles.component";
import { ListeCommandesComponent } from "./liste-commandes/liste-commandes.component";
import { LoginComponent } from "./login/login.component";
import { MarqueComponent } from "./marque/marque.component";
import { ModelCaracteristiqueComponent } from "./model-caracteristique/model-caracteristique.component";
import { AuthGuard } from "./services/auth.guard";
import { LoginGuard } from "./services/LoginGuard .guard";
import { ReferencementComponent } from "./referencement/referencement.component";
import { SettingsComponent } from "./settings/settings.component";

const routes: Routes = [
  { path: "", component: LoginComponent,canActivate: [LoginGuard] },
  { path: "admin/index", component: IndexComponent,
    canActivate: [AuthGuard]
   },
  {
    path: "admin/article/:param_code/:typeTrs",
    component: ArticleComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "admin/settings",
    component: SettingsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "admin/liste/article",
    component: ListeArticlesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "admin/categorie",
    component: CategorieComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "admin/caracteristique",
    component: CaracteristiqueComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "admin/modelcaracteristique",
    component: ModelCaracteristiqueComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "admin/banniere",
    component: BanniereComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "admin/referencement",
    component: ReferencementComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "admin/marque",
    component: MarqueComponent,
    canActivate: [AuthGuard]
  },
  { path: "link", component: LinkComponentComponent,canActivate: [AuthGuard] },
  {
    path: "content/manager",
    component: ContentManagerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "equipe/travail",
    component: EquipeTravailComponent,
    canActivate: [AuthGuard]
  },
  { path: "blogues", component: BloguesComponent,
    canActivate: [AuthGuard]
   },
  {
    path: "commandes",
    component: ListeCommandesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "instagram",
    component: InstagramComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "admin/groupe/categorie",
    component: GroupeCategorieComponent,
    canActivate: [AuthGuard]
  },
  { path: "**", redirectTo: "admin/index" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
